/*
 * @Author: ken yang
 * @Date: 2022-09-28 20:13:54
 * @LastEditTime: 2023-08-02 15:58:17
 * @LastEditors: ken yang
 * @Description:
 * @FilePath: /uexch_pc/src/view/user/index.js
 */
import AppLayout from '@/layout/AppLayout.vue'

// import Login from '@/view/user/Login.vue'
// import Register from '@/view/user/Register.vue'
// import ForgotPassword from '@/view/user/ForgotPassword.vue'

const Login = () => import('@/view/user/Login.vue')
const Register = () => import('@/view/user/Register.vue')
const RegisterUpLand = () => import('@/view/user/RegisterUpLand.vue')
const ForgotPassword = () => import('@/view/user/ForgotPassword.vue')
const SetNewPassword = () => import('@/view/user/SetNewPassword.vue')
const Auth = () => import('@/view/user/Auth.vue')
const ResetAuth1 = () => import('@/view/user/ResetAuth1.vue')
const ResetAuth2 = () => import('@/view/user/ResetAuth2.vue')
const ResetAuth3 = () => import('@/view/user/ResetAuth3.vue')
const ResetAuthGoogle = () => import('@/view/user/ResetAuthGoogle.vue')
const AccountDeletionNotice = () =>
  import('@/view/user/AccountDeletionNotice.vue')

const routes = [
  {
    component: AppLayout,
    children: [
      {
        path: '/login',
        component: Login,
      },
      {
        path: '/register',
        redirect: '/user/register',
      },
      {
        path: '/user/register',
        component: Register,
      },
      {
        path: '/loginAuth',
        component: Auth,
        props: route => ({ ...route.query }),
      },
      {
        path: '/resetAuth1',
        component: ResetAuth1,
        props: route => ({ ...route.query }),
      },
      {
        path: '/resetAuth2',
        component: ResetAuth2,
        props: route => ({ ...route.query }),
      },
      {
        path: '/resetAuth3',
        component: ResetAuth3,
        props: route => ({ ...route.query }),
      },
      {
        path: '/resetAuthGoogle',
        component: ResetAuthGoogle,
        props: route => ({ ...route.query }),
      },

      {
        path: '/ru',
        component: RegisterUpLand,
      },
      {
        path: '/forgotPassword',
        component: ForgotPassword,
      },
      {
        path: '/setNewPassword',
        props: (route) => ({ account: route.query.account }),
        component: SetNewPassword,
      },
      {
        path: '/user/accountDeletion',
        component: AccountDeletionNotice,
      },
    ],
  },
]
const components = {}

export default {
  routes,
  components,
}
